import type { Role } from "./api";

/** Plain-English labels for GET /api/health component keys. */
const HEALTH_LABELS: Record<string, string> = {
  qdrant: "Search index",
  minio: "Photo storage",
  vllm: "Description engine",
  status: "Overall",
};

/** Plain-English labels for pipeline / infra service slugs (events, ops). */
const SERVICE_LABELS: Record<string, string> = {
  deepstream: "Video capture",
  captioner: "Descriptions",
  embedder: "Search indexing",
  db_writer: "Data saver",
  preview: "Live preview",
  api: "Control plane",
  supervisor: "Host supervisor",
  janitor: "Maintenance",
  track_aggregator: "Activity tracking",
  redis: "Processing queues",
  qdrant: "Search index",
  minio: "Photo storage",
  vllm: "Description engine",
  prometheus: "Metrics",
  grafana: "Dashboards",
  go2rtc: "Live preview relay",
};

/** Map a backend service or health key to operator language. Dev role sees raw keys. */
export function labelForService(key: string, role: Role): string {
  if (role === "dev") return key;
  const k = key.toLowerCase();
  return SERVICE_LABELS[k] ?? HEALTH_LABELS[k] ?? key.replace(/_/g, " ");
}

/** Alias for health-check keys (same mapping, clearer call sites). */
export function labelForHealthKey(key: string, role: Role): string {
  return labelForService(key, role);
}
